// ACTION TYPE TOGGLE_ADVANCED_SEARCH
export const TOGGLE_ADVANCED_SEARCH = 'TOGGLE_ADVANCED_SEARCH';

// ACTION CREATOR toggleAdvancedSearch
export const toggleAdvancedSearch = () => ({
  type: TOGGLE_ADVANCED_SEARCH,
});

// ACTION TYPE SET_RADIUS_VALUE
export const SET_RADIUS_VALUE = 'SET_RADIUS_VALUE';

// ACTION CREATOR setRadiusValue
export const setRadiusValue = (value) => ({
  type: SET_RADIUS_VALUE,
  value,
});

// ACTION CREATOR SET_ACCORDION_EXPANDED
export const SET_ACCORDION_EXPANDED = 'SET_ACCORDION_EXPANDED';

// ACTION CREATOR setAccordionExpanded
export const setAccordionExpanded = (panel) => ({
  type: SET_ACCORDION_EXPANDED,
  panel,
});

// ACTION CREATOR TOGGLE_BACKGROUND_IMAGE
export const TOGGLE_BACKGROUND_IMAGE = 'TOOGLE_BACKGROUND_IMAGE';

// ACTION CREATOR toggleBackgroundImage
export const toggleBackgroundImage = () => ({
  type: TOGGLE_BACKGROUND_IMAGE,
});

// ACTION CREATOR TOGGLE_NETWORKS_MENU
export const TOGGLE_NETWORKS_MENU = 'TOOGLE_NETWORKS_MENU';

// ACTION CREATOR toggleNetworkMenu
export const toggleNetworkMenu = () => ({
  type: TOGGLE_NETWORKS_MENU,
});

// ACTION CREATOR SET_LOADING_MAP
export const SET_LOADING_MAP = 'SET_LOADING_MAP';

// ACTION CREATOR setLoadingMap
export const setLoadingMap = (loadingMapValue) => ({
  type: SET_LOADING_MAP,
  loadingMapValue,
});

// ACTION CREATOR SET_MAP_RESULTS
export const SET_MAP_RESULTS = 'SET_MAP_RESULTS';

// ACTION CREATOR setMapResults
export const setMapResults = (mapResults) => ({
  type: SET_MAP_RESULTS,
  mapResults,
});

// ACTION CREATOR SET_MARKERS_COLOR
export const SET_MARKERS_COLOR = 'SET_MARKERS_COLOR';

// ACTION CREATOR setMarkersColor
export const setMarkersColor = (value) => ({
  type: SET_MARKERS_COLOR,
  value,
});

// ACTION CREATOR SET_DATA_GRID_ROWS
export const SET_DATA_GRID_ROWS = 'SET_DATA_GRID_ROWS';

// ACTION CREATOR setDataGridRows
export const setDataGridRows = (value) => ({
  type: SET_DATA_GRID_ROWS,
  value,
});

// ACTION CREATOR SET_DATA_AVAILABLE
export const SET_DATA_AVAILABLE = 'SET_DATA_AVAILABLE';

// ACTION CREATOR setDataAvailable
export const setDataAvailable = (value) => ({
  type: SET_DATA_AVAILABLE,
  value,
});

// ACTION CREATOR SET_GREATER_LAT
export const SET_GREATER_LAT = 'SET_GREATER_LAT';

// ACTION CREATOR setGreaterLat
export const setGreaterLat = (value) => ({
  type: SET_GREATER_LAT,
  value,
});

// ACTION CREATOR SET_LESS_LAT
export const SET_LESS_LAT = 'SET_LESS_LAT';

// ACTION CREATOR setLessLat
export const setLessLat = (value) => ({
  type: SET_LESS_LAT,
  value,
});

// ACTION CREATOR SET_GREATER_LON
export const SET_GREATER_LON = 'SET_GREATER_LON';

// ACTION CREATOR setGreaterLon
export const setGreaterLon = (value) => ({
  type: SET_GREATER_LON,
  value,
});

// ACTION CREATOR SET_LESS_LON
export const SET_LESS_LON = 'SET_LESS_LON';

// ACTION CREATOR setLessLon
export const setLessLon = (value) => ({
  type: SET_LESS_LON,
  value,
});

// ACTION CREATOR SET_GREATER_ALT
export const SET_GREATER_ALT = 'SET_GREATER_ALT';

// ACTION CREATOR setGreaterAlt
export const setGreaterAlt = (value) => ({
  type: SET_GREATER_ALT,
  value,
});

// ACTION CREATOR SET_LESS_ALT
export const SET_LESS_ALT = 'SET_LESS_ALT';

// ACTION CREATOR setLessAlt
export const setLessAlt = (value) => ({
  type: SET_LESS_ALT,
  value,
});

// ACTION CREATOR SET_GREATER_INSTALL_DATE
export const SET_GREATER_INSTALL_DATE = 'SET_GREATER_INSTALL_DATE';

// ACTION CREATOR setGreaterInstallDate
export const setGreaterInstallDate = (value) => ({
  type: SET_GREATER_INSTALL_DATE,
  value,
});

// ACTION CREATOR SET_LESS_INSTALL_DATE
export const SET_LESS_INSTALL_DATE = 'SET_LESS_INSTALL_DATE';

// ACTION CREATOR setLessInstallDate
export const setLessInstallDate = (value) => ({
  type: SET_LESS_INSTALL_DATE,
  value,
});

// ACTION CREATOR SET_GREATER_END_DATE
export const SET_GREATER_END_DATE = 'SET_GREATER_END_DATE';

// ACTION CREATOR setGreaterEndDate
export const setGreaterEndDate = (value) => ({
  type: SET_GREATER_END_DATE,
  value,
});

// ACTION CREATOR SET_LESS_END_DATE
export const SET_LESS_END_DATE = 'SET_LESS_END_DATE';

// ACTION CREATOR setLessEndDate
export const setLessEndDate = (value) => ({
  type: SET_LESS_END_DATE,
  value,
});

// ACTION CREATOR SAVED_DATA_GRID_ROWS
export const SAVED_DATA_GRID_ROWS = 'SAVED_DATA_GRID_ROWS';

// ACTION CREATOR saveDataGridRows
export const saveDataGridRows = (value) => ({
  type: SAVED_DATA_GRID_ROWS,
  value,
});

// ACTION CREATOR SET_SAVE_LAYER
export const SET_SAVE_LAYER = 'SET_SAVE_LAYER';

// ACTION CREATOR setSaveLayer
export const setSaveLayer = (value) => ({
  type: SET_SAVE_LAYER,
  value,
});

// ACTION CREATOR SET_SAVE_RECTANGLE_BOUNDS
export const SET_SAVE_RECTANGLE_BOUNDS = 'SET_SAVE_RECTANGLE_BOUNDS';

// ACTION CREATOR setSaveRectangleBounds
export const setSaveRectangleBounds = (valueNorth, valueSouth, valueEast, valueWest) => ({
  type: SET_SAVE_RECTANGLE_BOUNDS,
  valueNorth,
  valueSouth,
  valueEast,
  valueWest,
});

// ACTION CREATOR SET_SAVE_RECTANGLE_NORTH
export const SET_SAVE_RECTANGLE_NORTH = 'SET_SAVE_RECTANGLE_NORTH';

// ACTION CREATOR setSaveRectangleNorth
export const setSaveRectangleNorth = (value) => ({
  type: SET_SAVE_RECTANGLE_NORTH,
  value,
});

// ACTION CREATOR SET_SAVE_RECTANGLE_SOUTH
export const SET_SAVE_RECTANGLE_SOUTH = 'SET_SAVE_RECTANGLE_SOUTH';

// ACTION CREATOR setSaveRectangleSouth
export const setSaveRectangleSouth = (value) => ({
  type: SET_SAVE_RECTANGLE_SOUTH,
  value,
});

// ACTION CREATOR SET_SAVE_RECTANGLE_EAST
export const SET_SAVE_RECTANGLE_EAST = 'SET_SAVE_RECTANGLE_EAST';

// ACTION CREATOR setSaveRectangleEast
export const setSaveRectangleEast = (value) => ({
  type: SET_SAVE_RECTANGLE_EAST,
  value,
});

// ACTION CREATOR SET_SAVE_RECTANGLE_WEST
export const SET_SAVE_RECTANGLE_WEST = 'SET_SAVE_RECTANGLE_WEST';

// ACTION CREATOR setSaveRectangleWest
export const setSaveRectangleWest = (value) => ({
  type: SET_SAVE_RECTANGLE_WEST,
  value,
});

// ACTION CREATOR SET_VALUE_CHANGE
export const SET_VALUE_CHANGE = 'SET_VALUE_CHANGE';

// ACTION CREATOR setValueChange
export const setValueChange = (value) => ({
  type: SET_VALUE_CHANGE,
  value,
});

// ACTION CREATOR SET_SAVE_CIRCLE_LAT
export const SET_SAVE_CIRCLE_LAT = 'SET_SAVE_CIRCLE_LAT';

// ACTION CREATOR setSaveCircleLat
export const setSaveCircleLat = (value) => ({
  type: SET_SAVE_CIRCLE_LAT,
  value,
});

// ACTION CREATOR SET_SAVE_CIRCLE_LON
export const SET_SAVE_CIRCLE_LON = 'SET_SAVE_CIRCLE_LON';

// ACTION CREATOR setSaveCircleLon
export const setSaveCircleLon = (value) => ({
  type: SET_SAVE_CIRCLE_LON,
  value,
});

// ACTION CREATOR SET_SAVE_CIRCLE
export const SET_SAVE_CIRCLE = 'SET_SAVE_CIRCLE';

// ACTION CREATOR setSaveCircle
export const setSaveCircle = (valueLat, valueLng, valueRadius) => ({
  type: SET_SAVE_CIRCLE,
  valueLat,
  valueLng,
  valueRadius,
});

// ACTION CREATOR SET_OPENTOUR
export const SET_OPENTOUR = 'SET_OPENTOUR';

// ACTION CREATOR setOpenTour
export const setOpenTour = (value) => ({
  type: SET_OPENTOUR,
  value,
});

// ACTION CREATOR SET_OPEN_POPPER
export const SET_OPEN_POPPER = 'SET_OPEN_POPPER';

// ACTION CREATOR setOpenPopper
export const setOpenPopper = (value) => ({
  type: SET_OPEN_POPPER,
  value,
});

// ACTION CREATOR SET_SAVE_NETWORK_CLICKED
export const SET_SAVE_NETWORK_CLICKED = 'SET_SAVE_NETWORK_CLICKED';

// ACTION CREATOR setSaveNetworkClicked
export const setSaveNetworkClicked = (value, name) => ({
  type: SET_SAVE_NETWORK_CLICKED,
  value,
  name,
});

// ACTION CREATOR SET_TOOLS_CHECKBOX
export const SET_TOOLS_CHECKBOX = 'SET_TOOLS_CHECKBOX';

// ACTION CREATOR setToolsCheckbox
export const setToolsCheckbox = (value) => ({
  type: SET_TOOLS_CHECKBOX,
  value,
});

// ACTION CREATOR SET_NETWORKS_ARRAY
export const SET_NETWORKS_ARRAY = 'SET_NETWORKS_ARRAY';

// ACTION CREATOR setNetworksArray
export const setNetworksArray = (networks) => ({
  type: SET_NETWORKS_ARRAY,
  networks,
});

// ACTION CREATOR SET_CLICK_ON_NETWORKS
export const SET_CLICK_ON_NETWORKS = 'SET_CLICK_ON_NETWORKS';

// ACTION CREATOR setClickOnNetworks
export const setClickOnNetworks = (value) => ({
  type: SET_CLICK_ON_NETWORKS,
  value,
});

// ACTION CREATOR SET_NEW_LIST
export const SET_NEW_LIST = 'SET_NEW_LIST';

// ACTION CREATOR setNewList
export const setNewList = (value) => ({
  type: SET_NEW_LIST,
  value,
});

// ACTION CREATOR SET_SELECT_ALL_CLICK
export const SET_SELECT_ALL_CLICK = 'SET_SELECT_ALL_CLICK';

// ACTION CREATOR setSelectAllClick
export const setSelectAllClick = (value) => ({
  type: SET_SELECT_ALL_CLICK,
  value,
});

// ACTION CREATOR SET_SELECT_INACTIVE
export const SET_SELECT_INACTIVE = 'SET_SELECT_INACTIVE';

// ACTION CREATOR setSelectInactive
export const setSelectInactive = (value) => ({
  type: SET_SELECT_INACTIVE,
  value,
});

// ACTION CREATOR FETCH_RECEIVER_LIST
export const FETCH_RECEIVER_LIST = 'FETCH_RECEIVER_LIST';

// ACTION CREATOR fetchReceiverList
export const fetchReceiverList = (server, glassapi) => ({
  type: FETCH_RECEIVER_LIST,
  server,
  glassapi,
});

// ACTION CREATOR SAVE_RECEIVER_LIST
export const SAVE_RECEIVER_LIST = 'SAVE_RECEIVER_LIST';

// ACTION CREATOR saveReceiverList
export const saveReceiverList = (value) => ({
  type: SAVE_RECEIVER_LIST,
  value,
});

// ACTION CREATOR FETCH_ANTENNA_LIST
export const FETCH_ANTENNA_LIST = 'FETCH_ANTENNA_LIST';

// ACTION CREATOR fetchAntennaList
export const fetchAntennaList = (server, glassapi) => ({
  type: FETCH_ANTENNA_LIST,
  server,
  glassapi,
});

// ACTION CREATOR SAVE_ANTENNA_LIST
export const SAVE_ANTENNA_LIST = 'SAVE_ANTENNA_LIST';

// ACTION CREATOR saveAntennaList
export const saveAntennaList = (value) => ({
  type: SAVE_ANTENNA_LIST,
  value,
});

// ACTION CREATOR FETCH_RADOME_LIST
export const FETCH_RADOME_LIST = 'FETCH_RADOME_LIST';

// ACTION CREATOR fetchRadomeList
export const fetchRadomeList = (server, glassapi) => ({
  type: FETCH_RADOME_LIST,
  server,
  glassapi,
});

// ACTION CREATOR SAVE_RADOME_LIST
export const SAVE_RADOME_LIST = 'SAVE_RADOME_LIST';

// ACTION CREATOR saveRadomeList
export const saveRadomeList = (value) => ({
  type: SAVE_RADOME_LIST,
  value,
});

// ACTION CREATOR FETCH_FILE_TYPE_LIST
export const FETCH_FILE_TYPE_LIST = 'FETCH_FILE_TYPE_LIST';

// ACTION CREATOR fetchFileTypeList
export const fetchFileTypeList = (server, glassapi) => ({
  type: FETCH_FILE_TYPE_LIST,
  server,
  glassapi,
});

// ACTION CREATOR SAVE_FILE_TYPE_LIST
export const SAVE_FILE_TYPE_LIST = 'SAVE_FILE_TYPE_LIST';

// ACTION CREATOR saveFileTypeList
export const saveFileTypeList = (value) => ({
  type: SAVE_FILE_TYPE_LIST,
  value,
});

// ACTION CREATOR SAVE_RECEIVER_TYPE_SELECTED
export const SAVE_RECEIVER_TYPE_SELECTED = 'SAVE_RECEIVER_TYPE_SELECTED';

// ACTION CREATOR saveReceiverTypeSelected
export const saveReceiverTypeSelected = (value) => ({
  type: SAVE_RECEIVER_TYPE_SELECTED,
  value,
});

// ACTION CREATOR SAVE_ANTENNA_TYPE_SELECTED
export const SAVE_ANTENNA_TYPE_SELECTED = 'SAVE_ANTENNA_TYPE_SELECTED';

// ACTION CREATOR saveAntennaTypeSelected
export const saveAntennaTypeSelected = (value) => ({
  type: SAVE_ANTENNA_TYPE_SELECTED,
  value,
});

// ACTION CREATOR SAVE_RADOME_TYPE_SELECTED
export const SAVE_RADOME_TYPE_SELECTED = 'SAVE_RADOME_TYPE_SELECTED';

// ACTION CREATOR saveRadomeTypeSelected
export const saveRadomeTypeSelected = (value) => ({
  type: SAVE_RADOME_TYPE_SELECTED,
  value,
});

// ACTION CREATOR SAVE_SATELLITE_SYSTEM_SELECTED
export const SAVE_SATELLITE_SYSTEM_SELECTED = 'SAVE_SATELLITE_SYSTEM_SELECTED';

// ACTION CREATOR saveSatelliteSystemSelected
export const saveSatelliteSystemSelected = (value) => ({
  type: SAVE_SATELLITE_SYSTEM_SELECTED,
  value,
});

// ACTION CREATOR SET_DATE_PICKER_ADVANCED_SEARCH_DATE_FROM
export const SET_DATE_PICKER_ADVANCED_SEARCH_DATE_FROM = 'SET_DATE_PICKER_ADVANCED_SEARCH_DATE_FROM';

// ACTION CREATOR setDatePickerAdvancedSearchDateFrom
export const setDatePickerAdvancedSearchDateFrom = (value) => ({
  type: SET_DATE_PICKER_ADVANCED_SEARCH_DATE_FROM,
  value,
});

// ACTION CREATOR SET_DATE_PICKER_ADVANCED_SEARCH_DATE_TO
export const SET_DATE_PICKER_ADVANCED_SEARCH_DATE_TO = 'SET_DATE_PICKER_ADVANCED_SEARCH_DATE_TO';

// ACTION CREATOR setDatePickerAdvancedSearchDateTo
export const setDatePickerAdvancedSearchDateTo = (value) => ({
  type: SET_DATE_PICKER_ADVANCED_SEARCH_DATE_TO,
  value,
});

// ACTION CREATOR SET_DATA_AVAILABILITY
export const SET_DATA_AVAILABILITY = 'SET_DATA_AVAILABILITY';

// ACTION CREATOR setDataAvailability
export const setDataAvailability = (value) => ({
  type: SET_DATA_AVAILABILITY,
  value,
});

// ACTION CREATOR SET_DAILY_OBSERVATION
export const SET_DAILY_OBSERVATION = 'SET_DAILY_OBSERVATION';

// ACTION CREATOR setDailyObservation
export const setDailyObservation = (value) => ({
  type: SET_DAILY_OBSERVATION,
  value,
});

// ACTION CREATOR SET_FILE_TYPE_SELECTED
export const SET_FILE_TYPE_SELECTED = 'SET_FILE_TYPE_SELECTED';

// ACTION CREATOR setFileTypeSelected
export const setFileTypeSelected = (value) => ({
  type: SET_FILE_TYPE_SELECTED,
  value,
});

// ACTION CREATOR SET_FILE_STATUS_SELECTED
export const SET_FILE_STATUS_SELECTED = 'SET_FILE_STATUS_SELECTED';

// ACTION CREATOR setFileStatusSelected
export const setFileStatusSelected = (value) => ({
  type: SET_FILE_STATUS_SELECTED,
  value,
});

// ACTION CREATOR SET_OBSERVATIONS_TYPES
export const SET_OBSERVATIONS_TYPES = 'SET_OBSERVATIONS_TYPES';

// ACTION CREATOR setObservationsTypes
export const setObservationsTypes = (value) => ({
  type: SET_OBSERVATIONS_TYPES,
  value,
});

// ACTION CREATOR SET_FREQUENCIES_BAND
export const SET_FREQUENCIES_BAND = 'SET_FREQUENCIES_BAND';

// ACTION CREATOR setFrequenciesBand
export const setFrequenciesBand = (value) => ({
  type: SET_FREQUENCIES_BAND,
  value,
});

// ACTION CREATOR SET_ATTRIBUTE_CHANNEL
export const SET_ATTRIBUTE_CHANNEL = 'SET_ATTRIBUTE_CHANNEL';

// ACTION CREATOR setAttributeChannel
export const setAttributeChannel = (value) => ({
  type: SET_ATTRIBUTE_CHANNEL,
  value,
});

// ACTION CREATOR SET_SATELLITE_SYSTEM_QC
export const SET_SATELLITE_SYSTEM_QC = 'SET_SATELLITE_SYSTEM_QC';

// ACTION CREATOR setSatelliteSystemQc
export const setSatelliteSystemQc = (value) => ({
  type: SET_SATELLITE_SYSTEM_QC,
  value,
});

// ACTION CREATOR SET_EPOCH_QC
export const SET_EPOCH_QC = 'SET_EPOCH_QC';

// ACTION CREATOR setEpochQc
export const setEpochQc = (value) => ({
  type: SET_EPOCH_QC,
  value,
});

// ACTION CREATOR SET_ELEVATION_QC
export const SET_ELEVATION_QC = 'SET_ELEVATION_QC';

// ACTION CREATOR setElevationQc
export const setElevationQc = (value) => ({
  type: SET_ELEVATION_QC,
  value,
});

// ACTION CREATOR SET_MULTIPATH_QC
export const SET_MULTIPATH_QC = 'SET_MULTIPATH_QC';

// ACTION CREATOR setMultipathQc
export const setMultipathQc = (value) => ({
  type: SET_MULTIPATH_QC,
  value,
});

// ACTION CREATOR SET_CYCLE_QC
export const SET_CYCLE_QC = 'SET_CYCLE_QC';

// ACTION CREATOR setCycleQc
export const setCycleQc = (value) => ({
  type: SET_CYCLE_QC,
  value,
});

// ACTION CREATOR SET_SINGLE_POINT_QC
export const SET_SINGLE_POINT_QC = 'SET_SINGLE_POINT_QC';

// ACTION CREATOR setSinglePointQc
export const setSinglePointQc = (value) => ({
  type: SET_SINGLE_POINT_QC,
  value,
});

// ACTION CREATOR SET_CLOCK_QC
export const SET_CLOCK_QC = 'SET_CLOCK_QC';

// ACTION CREATOR setClockQc
export const setClockQc = (value) => ({
  type: SET_CLOCK_QC,
  value,
});

// ACTION CREATOR SET_PARAMS
export const SET_PARAMS = 'SET_PARAMS';

// ACTION CREATOR setParams
export const setParams = (value) => ({
  type: SET_PARAMS,
  value,
});

// ACTION CREATOR SET_LOADING_CHART
export const SET_LOADING_CHART = 'SET_LOADING_CHART';

// ACTION CREATOR setLoadingChart
export const setLoadingChart = (loadingChartValue) => ({
  type: SET_LOADING_CHART,
  loadingChartValue,
});

// ACTION CREATOR SET_POLYGON_VALUE
export const SET_POLYGON_VALUE = 'SET_POLYGON_VALUE';

// ACTION CREATOR setPolygonValue
export const setPolygonValue = (value) => ({
  type: SET_POLYGON_VALUE,
  value,
});

// ACTION CREATOR FETCH_ALL_PAGES
export const FETCH_ALL_PAGES = 'FETCH_ALL_PAGES';

// ACTION CREATOR fetchAllPages
export const fetchAllPages = (value) => ({
  type: FETCH_ALL_PAGES,
  value,
});

// ACTION CREATOR SAVE_PAGES_LIST
export const SAVE_PAGES_LIST = 'SAVE_PAGES_LIST';

// ACTION CREATOR savePagesList
export const savePagesList = (value) => ({
  type: SAVE_PAGES_LIST,
  value,
});

// ACTION CREATOR SAVE_MARKER_GRID_FILTER
export const SAVE_MARKER_GRID_FILTER = 'SAVE_MARKER_GRID_FILTER';

// ACTION CREATOR saveMarkerGridFilter
export const saveMarkerGridFilter = (value) => ({
  type: SAVE_MARKER_GRID_FILTER,
  value,
});

// ACTION CREATOR SAVE_SITE_NAME_GRID_FILTER
export const SAVE_SITE_NAME_GRID_FILTER = 'SAVE_SITE_NAME_GRID_FILTER';

// ACTION CREATOR saveSiteNameGridFilter
export const saveSiteNameGridFilter = (value) => ({
  type: SAVE_SITE_NAME_GRID_FILTER,
  value,
});

// ACTION CREATOR SAVE_COUNTRY_GRID_FILTER
export const SAVE_COUNTRY_GRID_FILTER = 'SAVE_COUNTRY_GRID_FILTER';

// ACTION CREATOR saveCountryGridFilter
export const saveCountryGridFilter = (value) => ({
  type: SAVE_COUNTRY_GRID_FILTER,
  value,
});

// ACTION CREATOR SAVE_STATE_GRID_FILTER
export const SAVE_STATE_GRID_FILTER = 'SAVE_STATE_GRID_FILTER';

// ACTION CREATOR saveStateGridFilter
export const saveStateGridFilter = (value) => ({
  type: SAVE_STATE_GRID_FILTER,
  value,
});

// ACTION CREATOR SAVE_CITY_GRID_FILTER
export const SAVE_CITY_GRID_FILTER = 'SAVE_CITY_GRID_FILTER';

// ACTION CREATOR saveCityGridFilter
export const saveCityGridFilter = (value) => ({
  type: SAVE_CITY_GRID_FILTER,
  value,
});

// ACTION CREATOR SAVE_AGENCY_GRID_FILTER
export const SAVE_AGENCY_GRID_FILTER = 'SAVE_AGENCY_GRID_FILTER';

// ACTION CREATOR saveAgencyGridFilter
export const saveAgencyGridFilter = (value) => ({
  type: SAVE_AGENCY_GRID_FILTER,
  value,
});

// ACTION CREATOR SAVE_NETWORK_GRID_FILTER
export const SAVE_NETWORK_GRID_FILTER = 'SAVE_NETWORK_GRID_FILTER';

// ACTION CREATOR saveNetworkGridFilter
export const saveNetworkGridFilter = (value) => ({
  type: SAVE_NETWORK_GRID_FILTER,
  value,
});

// ACTION CREATOR SET_CLEAR_BUTTON
export const SET_CLEAR_BUTTON = 'SET_CLEAR_BUTTON';

// ACTION CREATOR setClearButton
export const setClearButton = (value) => ({
  type: SET_CLEAR_BUTTON,
  value,
});

// ACTION CREATOR SAVE_STRING_TO_CLIPBOARD
export const SAVE_STRING_TO_CLIPBOARD = 'SAVE_STRING_TO_CLIPBOARD';

// ACTION CREATOR saveStringToClipboard
export const saveStringToClipboard = (value) => ({
  type: SAVE_STRING_TO_CLIPBOARD,
  value,
});

// ACTION CREATOR EXPORT_CSV
export const EXPORT_CSV = 'EXPORT_CSV';

// ACTION CREATOR exportCsv
export const exportCsv = (value) => ({
  type: EXPORT_CSV,
  value,
});

// ACTION CREATOR FETCH_BACKEND_POPUP
export const FETCH_BACKEND_POPUP = 'FETCH_BACKEND_POPUP';

// ACTION CREATOR fetchBackendPopup
export const fetchBackendPopup = (query, backend) => ({
  type: FETCH_BACKEND_POPUP,
  query,
  backend,
});

// ACTION CREATOR SAVE_BACKEND_POPUP
export const SAVE_BACKEND_POPUP = 'SAVE_BACKEND_POPUP';

// ACTION CREATOR saveBackendPopup
export const saveBackendPopup = (value) => ({
  type: SAVE_BACKEND_POPUP,
  value,
});

// ACTION CREATOR SET_OPEN_BACKEND_MODAL
export const SET_OPEN_BACKEND_MODAL = 'SET_OPEN_BACKEND_MODAL';

// ACTION CREATOR setOpenBackendModal
export const setOpenBackendModal = (value) => ({
  type: SET_OPEN_BACKEND_MODAL,
  value,
});

// ACTION CREATOR SAVE_INVERTED_NETWORK
export const SAVE_INVERTED_NETWORK = 'SAVE_INVERTED_NETWORK';

// ACTION CREATOR saveInvertedNetwork
export const saveInvertedNetwork = (value) => ({
  type: SAVE_INVERTED_NETWORK,
  value,
});

// ACTION CREATOR SAVE_CELL_MOUSE_OVER_MARKER
export const SAVE_CELL_MOUSE_OVER_MARKER = 'SAVE_CELL_MOUSE_OVER_MARKER';

// ACTION CREATOR saveCellMouseOverMarker
export const saveCellMouseOverMarker = (value) => ({
  type: SAVE_CELL_MOUSE_OVER_MARKER,
  value,
});

// ACTION CREATOR SAVE_CELL_MOUSE_OUT_MARKER
export const SAVE_CELL_MOUSE_OUT_MARKER = 'SAVE_CELL_MOUSE_OUT_MARKER';

// ACTION CREATOR saveCellMouseOutMarker
export const saveCellMouseOutMarker = (value) => ({
  type: SAVE_CELL_MOUSE_OUT_MARKER,
  value,
});

// ACTION CREATOR SET_SELECT_ALL
export const SET_SELECT_ALL = 'SET_SELECT_ALL';

// ACTION CREATOR setSelectAll
export const setSelectAll = (value) => ({
  type: SET_SELECT_ALL,
  value,
});

// ACTION CREATOR SET_SAVE_COUNTRY_QUERY
export const SET_SAVE_COUNTRY_QUERY = 'SET_SAVE_COUNTRY_QUERY';

// ACTION CREATOR setSaveCountryQuery
export const setSaveCountryQuery = (value) => ({
  type: SET_SAVE_COUNTRY_QUERY,
  value,
});

// ACTION CREATOR SET_NEW_SLUG_QUERY
export const SET_NEW_SLUG_QUERY = 'SET_NEW_SLUG_QUERY';

// ACTION CREATOR setNewSlugQuery
export const setNewSlugQuery = (value) => ({
  type: SET_NEW_SLUG_QUERY,
  value,
});

// ACTION TYPE TOGGLE_SELECTED_MARKER
export const TOGGLE_SELECTED_MARKER = 'TOGGLE_SELECTED_MARKER';

// ACTION CREATOR toggleSelectedMarker
export const toggleSelectedMarker = (markerName) => ({
  type: TOGGLE_SELECTED_MARKER,
  markerName,
});
